<template>
  <main class="main_inner flex-grow-1">
    <div class="bank_area">
      <div class="bank_detail">
        <div class="card card_collapse border-0 rounded-0 bg-transparent">
          <input id="account_withdrawal" class="card_ipt d-none" type="checkbox" checked="" disabled="">
          <label class="card-header card_collapse_header card_lab border-0 mb-0" for="account_withdrawal">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="card_title mb-0">轉帳錢包</h5>
            </div>
          </label>
          <div class="card-body card_collapse_body">
            <div class="bank_pay_inner d-grid">
              <h5>錢包金額</h5>
              <div class="wallet_header_wrap row mb-4 d-flex flex-row align-items-center">
                <div class="flex-fill px-4 mx-4">
                  <div class="d-flex flex-column justify-content-center align-items-left">
                    <h5>主錢包</h5>
                    <h6 class="mb-0 text-white">
                      232,143
                    </h6>
                  </div>
                </div>
                <div class="flex-fill px-4 mx-4">
                  <div class="d-flex flex-column justify-content-center align-items-left">
                    <h5>佣金錢包</h5>
                    <h6 class="mb-0 text-white">
                      232,143
                    </h6>
                  </div>
                </div>
                <div class="flex-fill px-4 mx-4">
                  <div class="d-flex flex-row">
                    <div class="d-flex flex-fill flex-column justify-content-center align-items-left">
                      <h5>自動轉帳</h5>
                      <h6 class="mb-0 text-white">
                        開啟後自動轉入遊戲
                      </h6>
                    </div>
                    <div class="d-flex flex-fill align-items-center">
                      <label class="switch mb-0">
                        <input type="checkbox" checked>
                        <span class="slider round" />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="bank_pay_inner d-grid">
              <h5>錢包明細</h5>
              <form class="bank_pay_set mb-0" action="" autocomplete="off">
                <ul class="bank_pay_step d-grid list-unstyled mb-0">
                  <li>
                    <ul class="bank_pay_step_one d-flex list-unstyled mb-0">
                      <li v-for="(item, key) in list" :key="key">
                        <a
                          class="d-flex flex-column justify-content-center btn btn_outline btn_bank position-relative"
                          @click="showModal(item)"
                        >
                          <h5 class="">
                            {{ item.game_name }}
                          </h5>
                          <h6 class="mb-0">
                            {{ item.amount }}
                          </h6>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal_wallet"
      ref="modal_wallet"
      modal-class="modal_bet_detail"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      :hide-header="true"
      :hide-footer="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      content-class="modal-content"
    >
      <div class="modal-header justify-content-between align-items-center border-bottom-0">
        <h4 class="mb-0">
          <b class="text-white">轉帳金額</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" @click="hideModal()">
          <i class="icon-clear" />
        </button>
      </div>
      <div class="modal-body">
        <form>
          <h6>轉帳金額</h6>
          <div class="d-flex">
            <select class="form_ipt form-control">
              <option>主錢包</option>
              <option>佣金錢包</option>
            </select>
            <div class="align-self-center mx-4" style="color:#758cab">
              =>
            </div>
            <select class="form_ipt form-control">
              <option>主錢包</option>
              <option>佣金錢包</option>
            </select>
          </div>
          <br><br>
          <h6>轉帳金額</h6>
          <input type="number" class="form_ipt form-control">
          <br><br>
          <div class="d-flex justify-content-center">
            <button class="btn btn_outline btn_set rounded-pill" type="button">
              <span>立即轉帳</span>
            </button>
          </div>
        </form>
      </div>
    </b-modal>
  </main>
</template>

<script>

export default {
  data() {
    return {
      list: [
        {
          game_name: 'OB體育',
          amount: 3920
        },
        {
          game_name: 'OB體育',
          amount: 3920
        },
        {
          game_name: 'OB體育',
          amount: 3920
        },
        {
          game_name: 'OB體育',
          amount: 3920
        }
      ],
      user: false,
      selected: null
    }
  },
  methods: {
    showModal(item) {
      console.log('123')
      this.selected = item
      this.$bvModal.show('modal_wallet')
    },
    hideModal() {
      this.$bvModal.hide('modal_wallet')
    }
  }
}

</script>

<style scope>
.btn {
    text-align: left;
}
.wallet_header_wrap {
    /* margin-left: 30px;
    margin-right: 30px; */
}
.wallet_header_wrap > div {
    background-color: #29303a;
    border-radius: 20px;
    /* margin-bottom: 30px;
    padding-right: 30px; */
    /* width: calc((100% - 60px) / 1); */
    /* width: 100px; */
}
.wallet_header_wrap div.d-flex {
    height: 70px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 28px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 26px;
  left: 4px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #0cd664;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
